/* __next_internal_client_entry_do_not_use__ default,Input auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { APIProvider, useMapsLibrary } from '@vis.gl/react-google-maps';
import { useNewOrder } from '@/context/NewOrderContext';
import { OutlinedInput } from "__barrel_optimize__?names=OutlinedInput!=!@mui/material";
const API_KEY = process.env.NEXT_PUBLIC_MAPS_API_KEY;
export default function AddressField() {
    const { setOrder } = useNewOrder();
    const [selectedPlace, setSelectedPlace] = React.useState(null);
    useEffect(()=>{
        if (!selectedPlace) return;
        const addressComponents = selectedPlace.address_components || [];
        const getComponent = (type)=>{
            const component = addressComponents.find((comp)=>comp.types.includes(type));
            return component ? component.long_name : '';
        };
        setOrder((prev)=>({
                ...prev,
                vehicle_address: {
                    address_line_1: getComponent('street_number') + ' ' + getComponent('route'),
                    city: getComponent('locality'),
                    state: getComponent('administrative_area_level_1'),
                    zip_code: getComponent('postal_code')
                }
            }));
    }, [
        selectedPlace
    ]);
    return /*#__PURE__*/ _jsx(APIProvider, {
        apiKey: API_KEY,
        solutionChannel: "GMP_devsite_samples_v3_rgmautocomplete",
        children: /*#__PURE__*/ _jsx(Input, {
            onPlaceSelect: setSelectedPlace
        })
    });
}
export function Input(param) {
    let { onPlaceSelect } = param;
    const { order } = useNewOrder();
    const [inputValue, setInputValue] = useState('');
    const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
    const inputRef = useRef(null);
    const places = useMapsLibrary('places');
    // Initialize input with saved address from context
    useEffect(()=>{
        if (order.vehicle_address && order.vehicle_address.address_line_1) {
            const fullAddress = [
                order.vehicle_address.address_line_1,
                order.vehicle_address.city,
                order.vehicle_address.state,
                order.vehicle_address.zip_code
            ].filter(Boolean).join(', ');
            setInputValue(fullAddress);
        }
    }, [
        order.vehicle_address
    ]);
    useEffect(()=>{
        if (!places || !inputRef.current) return;
        const options = {
            fields: [
                'geometry',
                'name',
                'formatted_address',
                'address_components'
            ]
        };
        setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
    }, [
        places
    ]);
    useEffect(()=>{
        if (!placeAutocomplete) return;
        placeAutocomplete.addListener('place_changed', ()=>{
            onPlaceSelect(placeAutocomplete.getPlace());
        });
    }, [
        onPlaceSelect,
        placeAutocomplete
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "autocomplete-control md:col-span-3",
        children: /*#__PURE__*/ _jsx("div", {
            className: "autocomplete-container",
            children: /*#__PURE__*/ _jsx(OutlinedInput, {
                fullWidth: true,
                type: "text",
                inputRef: inputRef,
                name: "address",
                placeholder: "Enter vehicle location",
                value: inputValue,
                onChange: (e)=>setInputValue(e.target.value)
            })
        })
    });
}
